import { createContext, useState } from "react";

const AuthContext = createContext({});
/**
 * 
 * @param {*} param0 
 * @returns Authprovider for the whole app
 */
export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});
    const [persist, setPersist] = useState(() => {
        const raw = localStorage.getItem("persist");
        if (raw === null) return true;
        try {
            const parsed = JSON.parse(raw);
            return typeof parsed === "boolean" ? parsed : true;
        } catch {
            return raw === "true";
        }
    });

    return (
        <AuthContext.Provider value={{ auth, setAuth, persist, setPersist }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;
